import React from 'react';
import styled from 'styled-components';
import { UnstyledLink } from '../Link';
import { HeadlineCaption, P1 } from '../Typography/Paragraphs';
const PhoneLink = styled(P1) `
  font-family: ${({ theme }) => theme.fontFamilyBold};
  line-height: 24px;
  color: ${({ theme }) => theme.primaryRed};
  margin-top: 5px;
`;
const EmailLink = styled(PhoneLink) `
  font-family: ${({ theme }) => theme.fontFamilyBase};
  color: ${({ theme }) => theme.secondaryBlue};
  font-weight: normal;
  margin-top: 5px;
  padding-bottom: 20px;
`;
export const FooterNavigationContainer = styled.ul `
  list-style: none;
  padding-left: 0;
  margin: 0;
`;
const ItemContainer = styled.li `
  margin-bottom: 20px;
`;
const Label = styled(HeadlineCaption) `
  color: ${({ theme }) => theme.trueBlack};
  font-family: ${({ theme }) => theme.fontFamilyBase};
`;
const LabelLink = styled(Label) `
  &:hover {
    color: ${({ theme }) => theme.primaryRed};
  }
`;
const LabelField = styled(UnstyledLink) ``;
const NavItem = ({ fields }) => {
    const { url, label, phone, email } = fields;
    const { text: ariaLabel } = url.value;
    const urlValue = url.value.href;
    const phoneValue = phone.value;
    const phoneLink = 'tel:' + phoneValue;
    const emailValue = email.value;
    const emailLink = 'mailto:' + emailValue;
    return (React.createElement(React.Fragment, null,
        React.createElement(ItemContainer, null,
            urlValue !== '' ? (React.createElement(LabelField, { field: url, ariaLabel: ariaLabel },
                React.createElement(LabelLink, { field: label }))) : (React.createElement(Label, { field: label })),
            phoneValue && (React.createElement("address", null,
                React.createElement(UnstyledLink, { field: { value: { href: phoneLink } }, ariaLabel: phoneValue },
                    React.createElement(PhoneLink, { field: phone })))),
            emailValue && (React.createElement("address", null,
                React.createElement(UnstyledLink, { field: { value: { href: emailLink } }, ariaLabel: emailValue },
                    React.createElement(EmailLink, { field: email })))))));
};
export const FooterNavigationItems = ({ items }) => {
    const navItems = (React.createElement(React.Fragment, null, items.map(({ fields }, index) => {
        return React.createElement(NavItem, { fields: fields, key: index });
    })));
    return React.createElement(FooterNavigationContainer, null, navItems);
};
